import { aboutData } from '@/mocks/comicData';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-shrink-0 w-full lg:w-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20with%20manga%20and%20comic%20books%20on%20wooden%20shelf%2C%20warm%20ambient%20lighting%2C%20comfortable%20armchair%2C%20artistic%20atmosphere%2C%20soft%20natural%20light%20from%20window%2C%20clean%20minimal%20interior%2C%20warm%20cream%20and%20beige%20tones%2C%20professional%20photography%20style&width=720&height=480&seq=about-comic&orientation=landscape"
              alt="古古漫画网阅读场景"
              className="w-full aspect-[3/2] object-cover rounded-2xl"
            />
          </div>
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
              {aboutData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}